import { combineDucks } from "../helpers/combineDucks";
import { createFocasJobsActions } from "./focasJobsActions";
import { createFocasTriggersActions } from "./focasTriggersActions";
import { createFocasScriptsActions } from "./focasScriptActions";
import { createFocasConnectorsActions } from "./focasConnectorsActions";
export const focasJobsActionsDuck = createFocasJobsActions();
export const focasTriggersActionDuck = createFocasTriggersActions();
export const focasScriptsActionDuck = createFocasScriptsActions();
export const focasConnectorsActionDuck = createFocasConnectorsActions();
const combinedFocasJobsDucks = combineDucks(Object.assign({}, focasJobsActionsDuck));
const combinedFocasTriggersDucks = combineDucks(Object.assign({}, focasTriggersActionDuck));
const combinedFocasScriptsDucks = combineDucks(Object.assign({}, focasScriptsActionDuck));
const combinedFocasConnectorsDucks = combineDucks(Object.assign({}, focasConnectorsActionDuck));
export function createFocasJobsService() {
    return combinedFocasJobsDucks;
}
export function createFocasTriggersService() {
    return combinedFocasTriggersDucks;
}
export function createFocasScriptsService() {
    return combinedFocasScriptsDucks;
}
export function createFocasConnectorsService() {
    return combinedFocasConnectorsDucks;
}
//# sourceMappingURL=index.js.map